<template>
	<EMCoreTemplate category="OSMLife" identity="policyPremium" entity="osm_policy_premium"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/PolicyPremium.vue